import './Impressum.css'
import { Button, Modal } from 'antd'
import { FC, useState } from 'react'
import { impressumContent } from '../../contents/impressum'

export const Impressum: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="impressum-container">
      <Button onClick={showModal}>
        {impressumContent.title}
      </Button>
      <Modal
        title={impressumContent.title}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        <div className="impressum-content">
          <h2>{impressumContent.serviceProvider.title}</h2>
          <p><strong>Név:</strong> {impressumContent.serviceProvider.name}</p>
          <p><strong>E-mail:</strong> {impressumContent.serviceProvider.email}</p>
          <p><strong>Cím:</strong> {impressumContent.serviceProvider.address}</p>
          <p><strong>Tevékenység:</strong> {impressumContent.serviceProvider.activity}</p>

          <h2>{impressumContent.hostingProvider.title}</h2>
          <p><strong>Név:</strong> {impressumContent.hostingProvider.name}</p>
          <p><strong>Székhely:</strong> {impressumContent.hostingProvider.address}</p>
          <p><strong>E-mail:</strong> {impressumContent.hostingProvider.email}</p>

          <h2>{impressumContent.dataProtection.title}</h2>
          <p>{impressumContent.dataProtection.content}</p>

          <h2>{impressumContent.copyright.title}</h2>
          <p>{impressumContent.copyright.content}</p>

          <h2>{impressumContent.liability.title}</h2>
          <p>{impressumContent.liability.content}</p>
        </div>
      </Modal>
    </div>
  );

};
